import $ from 'jquery';
import Cookies from "js-cookie";
import {mobilebrowser} from '../detectmobilebrowsers.es6';

import * as CSS from 'bundle-text:./install.css';

const style = document.createElement('style');
style.textContent = CSS;
document.head.append(style);

const HIDE_COOKIE = 'ppp-cei';

export class ChromeExtensionInstallPromo {
    constructor() {
        this.disabled = !!Cookies.get(HIDE_COOKIE);
        this.container = null;
        this.element = $('#chrome_extension_promo2_template');
    }

    get enabled() {
        return !mobilebrowser() && !this.disabled && /studylib.net|flashcards|localhost/.test(document.location.host);
    }

    disable() {
        Cookies.set(HIDE_COOKIE, true, {expires: 365});
        this.disabled = true;
    }

    hide(remove) {
        this.disable();
        if (remove && this.container) {
            $(this.container).remove();
            this.container = null;
        }
    }

    show(el) {
        this.container = el;

        $(el)
            .append(this.element)
            .find('a[data-click=hide]').click(() => this.hide(true)).end();

        this.element.show();
    }
}